export const SETOR_CHART_ID = '#chart-setor'